import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useAuth } from '../../contexts/AuthContext';
import { loginSchema } from '../../utils/validationSchemas';
import LoadingSpinner from '../LoadingSpinner';
import './AuthForms.css';

const LoginForm = ({ onSwitchToRegister, onSwitchToForgotPassword }) => {
  const { login, isLoading, error, clearError } = useAuth();
  const [showPassword, setShowPassword] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting }
  } = useForm({
    resolver: yupResolver(loginSchema),
    mode: 'onBlur'
  });

  const onSubmit = async (data) => {
    clearError();
    const result = await login(data);
    if (result.success) {
      // Navigation will be handled by the app after auth state updates
      console.log('Login successful');
    }
  };

  return (
    <div className="auth-form">
      <div className="auth-header">
        <h2>Welcome back</h2>
        <p>Sign in to continue your reading journey</p>
      </div>

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit(onSubmit)} className="form">
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            {...register('email')}
            className={errors.email ? 'input-error' : ''}
            placeholder="Enter your email"
            autoComplete="email"
          />
          {errors.email && (
            <span className="field-error">{errors.email.message}</span>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="password">Password</label>
          <div className="password-input-container">
            <input
              id="password"
              type={showPassword ? 'text' : 'password'}
              {...register('password')}
              className={errors.password ? 'input-error' : ''}
              placeholder="Enter your password"
              autoComplete="current-password"
            />
            <button
              type="button"
              className="password-toggle"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? '👁️' : '👁️‍🗨️'}
            </button>
          </div>
          {errors.password && (
            <span className="field-error">{errors.password.message}</span>
          )}
        </div>

        <button
          type="submit"
          className="submit-button"
          disabled={isLoading || isSubmitting}
        >
          {isLoading || isSubmitting ? (
            <LoadingSpinner size="small" />
          ) : (
            'Sign in'
          )}
        </button>

        <div className="form-links">
          <button
            type="button"
            className="link-button"
            onClick={onSwitchToForgotPassword}
          >
            Forgot your password?
          </button>
        </div>

        <div className="form-footer">
          <p>
            Don't have an account?{' '}
            <button
              type="button"
              className="link-button primary"
              onClick={onSwitchToRegister}
            >
              Sign up
            </button>
          </p>
        </div>
      </form>
    </div>
  );
};

export default LoginForm;
